import * as React from "react";
import * as i from "../../../../contracts"
import { BetBtn } from "../";
import { observer } from "mobx-react";
/**
 * Sample usage :
 * <PreLiveOutright key={`k_${i}`} selections={selections} linkUrl={this.state.getOutrightUrl()} handler={this.state.openGameTranspiler} maxSelectionsToShow={this.cms.NumberOfSelectionsToShow}>{this.props.children}</PreLiveOutright>
 */
export type OutrightProps = {
    market: i.Market,
    numberOfSelectionsToShow: number,
    betButtonHandler: (market: i.Market, selection: i.Selection) => void
}
@observer
export class PreLiveOutright extends React.Component<OutrightProps, {}>{
    componentPrefix: string

    constructor(props) {
        super(props);
        this.componentPrefix = "prelive-outright";
    }

    renderButtonsHolder(s: i.Selection) {
        return (
            <div key={`${this.componentPrefix}__button-holder__${s.id}`} className="rj-ev-list__prelive-outright__button-holder" data-uat={`div-ev-list-${this.componentPrefix}-button-holder`}>
                <BetBtn
                    key={`${this.componentPrefix}__bet-btn__${s.id}`}
                    classNames={s.isSelectionInBetslip ? "rj-ev-list__bet-btn--chosen" : ""}
                    isDisabled={s.isDisabled}
                    text={s.name}
                    odd={s.odds}
                    handler={() => this.props.betButtonHandler(this.props.market, s)}>
                </BetBtn>
            </div>
        )
    }

    renderSelections(): JSX.Element[] {
        const viewOutright: JSX.Element[] = [];
        let selections = this.props.market.selections;

        const count = this.props.market.selections.length > this.props.numberOfSelectionsToShow
            ? this.props.numberOfSelectionsToShow
            : this.props.market.selections.length;

        for (let i = 0; i < count; i += 1) {
            viewOutright.push(
                this.renderButtonsHolder(selections[i])
            )
        }

        (selections.length > count) &&
            viewOutright.push(
                <React.Fragment key={`${this.componentPrefix}-${this.props.market.id}`}>
                    {this.props.children}
                </React.Fragment>
            );

        return viewOutright;
    }

    render() {
        return (
            <div className={`rj-ev-list__${this.componentPrefix}__wrap`} data-uat={`div-ev-list-${this.componentPrefix}-wrap`}>
                {this.renderSelections()}
            </div>
        )
    }
}